export const ingredientTypes = {
  ru: {
    bun: "Булки",
    main: "Начинка",
    sauce: "Соусы",
  },
  eng: {
    bun: "bun",
    main: "main",
    sauce: "sauce",
  },
};
